import type { DefaultTheme } from 'styled-components';

const breakpoints = {
  mobile: 500,
  tablet: 800,
  desktop: 1200,
  telly: 1600,
};

export type BreakpointName = keyof typeof breakpoints;

type ThemeWithBreakpoints = DefaultTheme & {
  Breakpoints?: Partial<Record<BreakpointName, number>>;
};

export function getBreakpoint(breakpoint: BreakpointName, theme?: ThemeWithBreakpoints) {
  if (theme?.Breakpoints?.[breakpoint]) {
    return theme.Breakpoints[breakpoint];
  }
  return breakpoints[breakpoint];
}

export function breakpointUp(breakpoint: BreakpointName, theme?: ThemeWithBreakpoints) {
  return `@media (min-width: ${getBreakpoint(breakpoint, theme)}px)`;
}

export function breakpointDown(breakpoint: BreakpointName, theme?: ThemeWithBreakpoints) {
  return `@media (max-width: ${getBreakpoint(breakpoint, theme) - 1}px)`;
}

export function breakpointBetween(
  breakpointA: BreakpointName,
  breakpointB: BreakpointName,
  theme?: ThemeWithBreakpoints,
) {
  return `@media (min-width: ${getBreakpoint(breakpointA, theme)}px) and (max-width: ${getBreakpoint(breakpointB, theme) - 1}px)`;
}

export default breakpoints;
